import { render, staticRenderFns } from "./CleanExcludedCnpjsConfirm.vue?vue&type=template&id=81f0ea08&scoped=true&"
import script from "./CleanExcludedCnpjsConfirm.vue?vue&type=script&lang=ts&"
export * from "./CleanExcludedCnpjsConfirm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81f0ea08",
  null
  
)

export default component.exports